import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Projects from './components/Projects';
import CompanyVideo from './components/CompanyVideo';
import Footer from './components/Footer';
import ProductsPage from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import AboutCompany from './pages/AboutCompany';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [selectedProduct, setSelectedProduct] = useState(null);

  const navigateTo = (page) => {
    setCurrentPage(page);
    setSelectedProduct(null);
    window.scrollTo(0, 0);
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setCurrentPage('product-detail');
    window.scrollTo(0, 0);
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'products':
        return <ProductsPage onProductClick={handleProductClick} />;
      case 'product-detail':
        return (
          <ProductDetail
            product={selectedProduct}
            onBack={() => navigateTo('products')}
          />
        );
      case 'about-company':
        return <AboutCompany />;
      default:
        return (
          <>
            <Hero />
            <Services />
            <About />
            <CompanyVideo />
            <Projects />
          </>
        );
    }
  };

  return (
    <div className="App">
      <Header onNavigate={navigateTo} currentPage={currentPage} />
      <main>
        {renderPage()}
      </main>
      <Footer onNavigate={navigateTo} />
    </div>
  );
}

export default App;
